<template>
  <div class="echarts-container" ref="chartContainer"></div>
</template>

<script>
import echarts from "echarts";

export default {
  name: "EChartsComponent",
  props: {
    funcData: {
      type: String,
      default: '[]',
    },
    funcDataOne: {
      type: String,
      default: "[]",
    },
    funcDataTwo: {
      type: String,
      default: "[]",
    },
    funcDataThree: {
      type: String,
      default: "[]",
    },
    funcDataFour: {
      type: String,
      default: "[]",
    },
    funcDataFive: {
      type: String,
      default: "[]",
    }
  },
  mounted() {
    this.renderChart();
  },
  methods: {
    func(x) {
      x /= 10;
      return Math.sin(x) * Math.cos(x * 2 + 1) * Math.sin(x * 3 + 2) * 50 * 100;
    },
    renderChart() {
      const chartContainer = this.$refs.chartContainer;
      // console.log(echarts, "echartsechartsecharts");
      const chart = echarts.init(chartContainer);

      // 使用 this.chartData 中的数据进行配置
      // const { xAxisData, seriesData } = this.chartData;
      // let data = [];
      // for (let i = -80; i <= 20; i += 1) {
      //   data.push([i, this.func(i)]);
      // }
      const dateList = Array.from({ length: 960 }, (_, i) => i + 1);
      // const valueList = data.map(function(item) {
      //   return item;
      // });
      const options = {
        backgroundColor: "#373b47",
        // Make gradient line here
        visualMap: [
          {
            show: false,
            type: "continuous",
            seriesIndex: 0,
            max: 400,
          },
          {
            show: false,
            type: "continuous",
            seriesIndex: 1,
            max: 400,
          },
          {
            show: false,
            type: "continuous",
            seriesIndex: 2,
            max: 400,
          },
          {
            show: false,
            type: "continuous",
            seriesIndex: 3,
            max: 400,
          },
          {
            show: false,
            type: "continuous",
            seriesIndex: 4,
            max: 400,
          },
          {
            show: false,
            type: "continuous",
            seriesIndex: 5,
            max: 400,
          },
          
        ],
        tooltip: {
          trigger: "axis",
          formatter: function(params) {

            if (!params || params.length === 0) return "";
            // 排序
            params.sort((a, b) => a.axisIndex - b.axisIndex);

            let html = ``;
            params.forEach((item, index) => {
              if (index == 0) {
                html += `
             <div style="color:#fff;padding: 0 10px 10px 10px">秒：${
               item.axisValue
             }</div>
                <div style="color:#fff;display: flex;flex-flow: row nowrap;align-items: center;padding:10px;border-top:1px solid rgba(255,255,255,.2)">
                  <div style="width:10px;height:10px;background:${
                    index == 0
                      ? "#9c9c00"
                      : index == 1
                      ? "red"
                      : index == 2
                      ? "#9c9c00"
                      : index == 3
                      ? "#41572b"
                      : index == 4
                      ? "#9c9c00"
                      : index == 5
                      ? "#006c00"
                      : index == 6
                      ? "red"
                      : index == 7
                      ? "#83af57"
                      : ""
                  };border-radius:10px;margin-right:10px"></div>
                  <div>
                    <p style="color:#fff;">类型：${
                      index == 0
                        ? "Ua"
                        : index == 1
                        ? "Ub"
                        : index == 2
                        ? "Uc"
                        : index == 3
                        ? "Ia"
                        : index == 4
                        ? "Ib"
                        : index == 5
                        ? "Ic"
                        : index == 6
                        ? "In"
                        : index == 7
                        ? "IL"
                        : ""
                    }</p>
                    <p style="color:#fff;">数值：${item.value}</p>
                  </div>
                </div>
              `;
              } else {
                html += `
                <div style="color:#fff;display: flex;flex-flow: row nowrap;align-items: center;padding:10px;border-top:1px solid rgba(255,255,255,.2)">
                  <div style="width:10px;height:10px;background:${
                    index == 0
                      ? "#9c9c00"
                      : index == 1
                      ? "red"
                      : index == 2
                      ? "#9c9c00"
                      : index == 3
                      ? "#41572b"
                      : index == 4
                      ? "#9c9c00"
                      : index == 5
                      ? "#006c00"
                      : index == 6
                      ? "red"
                      : index == 7
                      ? "#83af57"
                      : ""
                  };border-radius:10px;margin-right:10px"></div>
                  <div>
                    <p style="color:#fff;">类型：${
                      index == 0
                        ? "Ua"
                        : index == 1
                        ? "Ub"
                        : index == 2
                        ? "Uc"
                        : index == 3
                        ? "Ia"
                        : index == 4
                        ? "Ib"
                        : index == 5
                        ? "Ic"
                        : index == 6
                        ? "In"
                        : index == 7
                        ? "IL"
                        : ""
                    }</p>
                    <p style="color:#fff;">数值：${item.value}</p>
                  </div>
                </div>
              `;
              }
            });

            return html;
          },
        },
        axisPointer: {
          link: [
            {
              xAxisIndex: "all",
            },
          ],
        },
        xAxis: [
          {
            name: "",
            data: dateList,
            // show: false,
            minorTick: {
              show: true,
            },
            minorSplitLine: {
              show: true,
            },
            axisLabel: {
              color: "#373b47", // 修改X轴标签文字颜色为红色
            },
            axisLine: {
              lineStyle: {
                color: "#FFFFFF", // x 轴的颜色
              },
            },
            splitLine: {
              show: false,
            },
            minorSplitLine: {
              show: false,
            },
          },
          {
            name: "",
            data: dateList,
            gridIndex: 1,
            minorTick: {
              show: true,
            },
            minorSplitLine: {
              show: true,
            },
            axisLabel: {
              color: "#373b47", // 修改X轴标签文字颜色为红色
            },
            axisLine: {
              lineStyle: {
                color: "#FFFFFF", // x 轴的颜色
              },
            },
            splitLine: {
              show: false,
            },
            minorSplitLine: {
              show: false,
            },
          },
          {
            name: "",
            data: dateList,
            gridIndex: 2,
            minorTick: {
              show: true,
            },
            minorSplitLine: {
              show: true,
            },
            axisLabel: {
              color: "#373b47", // 修改X轴标签文字颜色为红色
            },
            axisLine: {
              lineStyle: {
                color: "#FFFFFF", // x 轴的颜色
              },
            },
            splitLine: {
              show: false,
            },
            minorSplitLine: {
              show: false,
            },
          },
          {
            name: "",
            data: dateList,
            gridIndex: 3,
            minorTick: {
              show: true,
            },
            minorSplitLine: {
              show: true,
            },
            axisLabel: {
              color: "#373b47", // 修改X轴标签文字颜色为红色
            },
            axisLine: {
              lineStyle: {
                color: "#FFFFFF", // x 轴的颜色
              },
            },
            splitLine: {
              show: false,
            },
            minorSplitLine: {
              show: false,
            },
          },
          {
            name: "",
            data: dateList,
            gridIndex: 4,
            minorTick: {
              show: true,
            },
            minorSplitLine: {
              show: true,
            },
            axisLabel: {
              color: "#373b47", // 修改X轴标签文字颜色为红色
            },
            axisLine: {
              lineStyle: {
                color: "#FFFFFF", // x 轴的颜色
              },
            },
            splitLine: {
              show: false,
            },
            minorSplitLine: {
              show: false,
            },
          },
          {
            name: "",
            data: dateList,
            gridIndex: 5,
            minorTick: {
              show: true,
            },
            minorSplitLine: {
              show: true,
            },
            axisLabel: {
              color: "#373b47", // 修改X轴标签文字颜色为红色
            },
            axisLine: {
              lineStyle: {
                color: "#FFFFFF", // x 轴的颜色
              },
            },
            splitLine: {
              show: false,
            },
            minorSplitLine: {
              show: false,
            },
          }
        ],
        yAxis: [
          {
            type: "value",
            scale: true,
            axisLabel: {
              color: "#FFFFFF", // 修改X轴标签文字颜色
            },
            axisLine: {
              // 设置Y轴线的样式
              lineStyle: {
                color: "#FFFFFF",
              },
            },
            splitLine: {
              show: false,
            },
          },
          {
            type: "value",
            scale: true,
            gridIndex: 1,
            axisLabel: {
              color: "#FFFFFF", // 修改X轴标签文字颜色为红色
            },
            axisLine: {
              // 设置Y轴线的样式
              lineStyle: {
                color: "#FFFFFF", // 修改为蓝色
              },
            },
            splitLine: {
              show: false,
            },
          },
          {
            type: "value",
            scale: true,
            gridIndex: 2,
            axisLabel: {
              color: "#FFFFFF", // 修改X轴标签文字颜色为红色
            },
            axisLine: {
              // 设置Y轴线的样式
              lineStyle: {
                color: "#FFFFFF", // 修改为蓝色
              },
            },
            splitLine: {
              show: false,
            },
          },
          {
            type: "value",
            scale: true,
            gridIndex: 3,
            axisLabel: {
              color: "#FFFFFF", // 修改X轴标签文字颜色为红色
            },
            axisLine: {
              // 设置Y轴线的样式
              lineStyle: {
                color: "#FFFFFF", // 修改为蓝色
              },
            },
            splitLine: {
              show: false,
            },
          },
          {
            type: "value",
            scale: true,
            gridIndex: 4,
            axisLabel: {
              color: "#FFFFFF", // 修改X轴标签文字颜色为红色
            },
            axisLine: {
              // 设置Y轴线的样式
              lineStyle: {
                color: "#FFFFFF", // 修改为蓝色
              },
            },
            splitLine: {
              show: false,
            },
          },
          {
            type: "value",
            scale: true,
            gridIndex: 5,
            axisLabel: {
              color: "#FFFFFF", // 修改X轴标签文字颜色为红色
            },
            axisLine: {
              // 设置Y轴线的样式
              lineStyle: {
                color: "#FFFFFF", // 修改为蓝色
              },
            },
            splitLine: {
              show: false,
            },
          }
        ],
        grid: [
          {
            top: "3%",
            bottom: "85%",
          },
          {
            top: "21%",
            bottom: "64%",
          },
          {
            top: "38%",
            bottom: "47%",
          },
          {
            top: "55%",
            bottom: "30%",
          },
          {
            top: "73%",
            bottom: "12%",
          },
          {
            top: "90%",
            bottom: "3%",
          }
        ],
        series: [
          {
            name: "Series",
            type: "line",
            showSymbol: false,
            data: JSON.parse(this.funcData),
            xAxisIndex: 0,
            yAxisIndex: 0,
            clip: true,
            lineStyle: {
              color: "#9c9c00", // 折线的颜色
              width: 2,
            },
          },
          {
            name: "Series",
            type: "line",
            showSymbol: false,
            data: JSON.parse(this.funcDataOne),
            xAxisIndex: 1,
            yAxisIndex: 1,
            clip: true,
            lineStyle: {
              color: "red", // 折线的颜色
              width: 2,
            },
          },
          {
            name: "Series",
            type: "line",
            showSymbol: false,
            data: JSON.parse(this.funcDataTwo),
            xAxisIndex: 2,
            yAxisIndex: 2,
            clip: true,
            lineStyle: {
              color: "#9c9c00", // 折线的颜色
            },
          },
          {
            name: "Series",
            type: "line",
            showSymbol: false,
            data: JSON.parse(this.funcDataThree),
            xAxisIndex: 3,
            yAxisIndex: 3,
            clip: true,
            lineStyle: {
              color: "#41572b",
              width: 2,
            },
          },
          {
            name: "Series",
            type: "line",
            showSymbol: false,
            data: JSON.parse(this.funcDataFour),
            xAxisIndex: 4,
            yAxisIndex: 4,
            clip: true,
            lineStyle: {
              color: "#9c9c00", // 折线的颜色
              width: 2,
            },
          },
          {
            name: "Series",
            type: "line",
            showSymbol: false,
            data: JSON.parse(this.funcDataFive),
            xAxisIndex: 5,
            yAxisIndex: 5,
            clip: true,
            lineStyle: {
              color: "#006c00", // 折线的颜色
              width: 2,
            },
          }
        ],
      };

      // 渲染图表
      chart.setOption(options);
    },
  },
};
</script>

<style>
.echarts-container {
  width: 100%;
  height: 800px;
}
</style>
